import { FunctionComponent, ReactNode } from 'react'

const IconWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => <>{children}</>

export default IconWrapper
